/**
 * Theme Configuration
 * 
 * Controls seasonal themes and visual effects
 */

/**
 * Enable Christmas theme with snowflakes and festive styling
 * Set to false to disable Christmas theme
 */
export const ENABLE_CHRISTMAS_THEME = false

/**
 * Enable vacation theme with beach styling (sand, sea, sun)
 * Set to false to disable vacation theme
 */
export const ENABLE_VACATION_THEME = false

/**
 * Team names for vacation-theme fish easter eggs (9 employees)
 */
export const VACATION_FISH_NAMES = [
  "Χρήστος",
  "Αγγελος",
  "Σταυρος",
  "Δημήτρης",
  "Θεόφιλος",
  "Καρυοφιλλιά",
  "Βασίλης",
  "Οδυσσέας",
  "Επαμεινώνδας",
] as const
